import { cn } from '@eliadmin/core/src/utils/style-utils';

export function FilesSkeleton() {
  return (
    <div className={cn('animate-pulse', 'flex w-full flex-col gap-2')}>
      {[...Array(5)].map((_, index) => (
        <div key={index} className="h-[90px] w-full bg-neutral-50" />
      ))}
    </div>
  );
}
